<div class="space-y-6">
  <h3 class="text-lg font-bold mb-6">
    {{ 'project.steps.projectChart.scopeDefinition' | transloco }}
  </h3>
  <div class="space-y-6">
    @for (section of scopeSections(); track section.key) {
      <div class="rich-text-section space-y-4">
        <div class="relative w-full">
          <app-rich-text-editor
            [key]="section.key"
            [initialContent]="section.content"
            [tooltipKey]="section.tooltipKey"
            [saveHandler]="richTextService"
            [disabled]="isButtonDisabled()"
            (statusChange)="onStatusChange()"
            class="w-full"
            [attr.data-testid]="'rich-text-editor-' + section.key"
          >
          </app-rich-text-editor>
        </div>
      </div>
    }
  </div>
</div>
